import type {
  FrontMenuPermissionsType,
  QuestCategoriesType,
  CourseCategoriesType,
  ServicePermissionsType,
} from '../../types/license_types';
import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';
import { contracts } from './contracts';
import { organizationUsers } from './organization_users';

type Licenses = CommonColumns & {
  resourceName: string;
  contractId: string;
  id: string;
  name: string;
  amount: string;
  period: string;
  startsAt: string;
  endsAt: string;
  supplementNotes: string;
  flexible: string;
  questPermitted: string;
  competitionPermitted: string;
  dxCopilotPlannerPermitted: string;
  dxCopilotAnalyticsPermitted: string;
  assigned: string;
  remaining: string;
  licensePermission: string;
  frontMenuPermissions: string;
  questCategoryPermissions: string;
  questPermissions: string;
  gymPermissions: string;
  courseCategoryPermissions: string;
  coursePermissions: string;
  abilityAssessmentPermissions: string;
  privateCompetition: string;
  program: string;
  dxaPromotion: string;
  restrictedQuestView: string;
  operation: string;
};

const dxCopilotPlanner = 'DXCopilot Planner';
const dxCopilotAnalytics = 'DXCopilot Analytics';

export const licenses: Readonly<Licenses> = {
  ...commonColumns,
  ...{
    resourceName: 'ライセンス',
    contractId: `${contracts.resourceName}${contracts.id}`,
    id: 'ライセンスID',
    name: 'ライセンス名',
    amount: '購入数',
    period: '期間',
    startsAt: '利用開始日',
    endsAt: '利用終了日',
    supplementNotes: '明細補足',
    flexible: `${organizationUsers.resourceName}付け替え`,
    questPermitted: 'Quest',
    competitionPermitted: 'Competition',
    dxCopilotPlannerPermitted: dxCopilotPlanner,
    dxCopilotAnalyticsPermitted: dxCopilotAnalytics,
    assigned: '割り当て済み数',
    remaining: '登録可能人数',
    licensePermission: '提供サービス詳細',
    frontMenuPermissions: 'メニュー表示',
    questCategoryPermissions: 'Questカテゴリ',
    questPermissions: 'Quest',
    gymPermissions: 'Gym',
    courseCategoryPermissions: 'Courseカテゴリ',
    coursePermissions: 'Course',
    abilityAssessmentPermissions: 'テスト',
    privateCompetition: 'Private Competition',
    program: 'プログラム',
    dxaPromotion: 'DXA-P',
    restrictedQuestView: '視聴制限',
    operation: '操作',
  },
};

export const licensesFlexibleName = (flexible: 'true' | 'false' | boolean) => {
  const parsedFlexible: boolean =
    typeof flexible === 'boolean' ? flexible : JSON.parse(flexible);

  return parsedFlexible ? '許可する' : '許可しない';
};

export const licensesFrontMenuPermissionsName = (
  frontMenuPermission: FrontMenuPermissionsType | undefined
) => {
  switch (frontMenuPermission) {
    case 'programs':
      return 'プログラム';
    case 'assessments':
      return 'テスト';
    case 'courses':
      return 'Course';
    case 'quests':
      return 'Quest';
    case 'gyms':
      return 'Gym';
    case 'private_competition':
      return 'Private Competition';
    case 'dx_copilot_planner':
      return dxCopilotPlanner;
    case 'dx_copilot_analytics':
      return dxCopilotAnalytics;
    default:
      return '';
  }
};

export const licensesCourseCategoryPermissionsName = (
  courseCategoryPermission: CourseCategoriesType | undefined
) => {
  switch (courseCategoryPermission) {
    case 'course':
      return 'Course';
    case 'organization_course':
      return '限定公開Course';
    case 'organization_limited':
      return '組織限定Course';
    default:
      return '';
  }
};

export const licensesQuestCategoryPermissionsName = (
  questCategoryPermission: QuestCategoriesType | undefined
) => {
  switch (questCategoryPermission) {
    case 'normal':
      return 'Quest';
    case 'gym':
      return 'Gym';
    case 'organization_normal':
      return '限定Quest';
    case 'organization_gym':
      return '限定Gym';
    default:
      return '';
  }
};

export const servicePermissionsName = (
  servicePermissions: ServicePermissionsType | undefined
) => {
  switch (servicePermissions) {
    case 'competition':
      return 'Competition';
    case 'quest':
      return 'Quest';
    case 'dxCopilotPlanner':
      return dxCopilotPlanner;
    case 'dxCopilotAnalytics':
      return dxCopilotAnalytics;
    default:
      return '';
  }
};
